import React from 'react'
import { motion } from 'framer-motion'

const features = [
  {
    title: "Professional Quality",
    description: "Every design is crafted with attention to detail and professional standards",
    bar: "bg-orange-500",
    glow: "hover:shadow-orange-100 hover:border-orange-300"
  },
  {
    title: "Fast Turnaround",
    description: "Quick delivery without compromising on quality or attention to detail",
    bar: "bg-red-500",
    glow: "hover:shadow-red-100 hover:border-red-300"
  },
  {
    title: "Creative Excellence",
    description: "Innovative designs that capture your vision and exceed expectations",
    bar: "bg-pink-500",
    glow: "hover:shadow-pink-100 hover:border-pink-300"
  }
]

const AboutBrief = () => {
  return (
    <section className="relative overflow-hidden bg-white py-24 md:py-32 text-slate-900">
      {/* background glows */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -top-32 -left-32 h-96 w-96 rounded-full bg-orange-200/40 blur-3xl"
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -bottom-40 -right-24 h-96 w-96 rounded-full bg-pink-200/40 blur-3xl"
      />

      <div className="relative max-w-6xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-end"
        >
          <h2 className="text-5xl md:text-7xl font-extrabold tracking-tight leading-[1.02]">
            Welcome to{' '}
            <span className="bg-gradient-to-r from-orange-500 via-red-500 to-pink-500 bg-clip-text text-transparent">
              Vector Visionary
            </span>
          </h2>
          <p className="text-lg md:text-xl text-slate-600 leading-relaxed">
            We are a team of passionate designers and digital artists dedicated to transforming your creative ideas into stunning vector graphics.
            With years of experience in the industry, we specialize in creating scalable, high-quality designs that work perfectly across all platforms and sizes.
          </p>
        </motion.div>

        <div className="mt-16 md:mt-24 grid grid-cols-1 md:grid-cols-3 gap-5">
          {features.map((feature, index) => (
            <motion.div
              key={feature.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className={`group relative overflow-hidden rounded-3xl border border-slate-200 bg-white p-8 pt-10 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl ${feature.glow}`}
            >
              <div className={`absolute left-0 top-0 h-1.5 w-full ${feature.bar}`} />
              <h3 className="text-2xl font-bold tracking-tight mb-4">{feature.title}</h3>
              <p className="text-slate-600 leading-relaxed">{feature.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default AboutBrief